<div class="rd-widget rd-widget-no-height-restriction land-registry-tenure-widget widget-{{widgetConfig.widgetId}} widgetNoTopBorder" *ngIf="widgetData">
  <table class="widget-large land-registry-table" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" colspan="12" class="widget-grid-column land-registry-tenure-widget-red">
          <ng-container *ngIf="editMode">
            <div class="land-registry-tenure-widget-header">
              <span class="k-icon k-i-minus" (click)="deleteCurrentRow()"></span>
              <span class="k-icon k-i-plus" (click)="addRow()" *ngIf="sectionHasAvailableFields('landRegistryTenure')"></span>
              <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp()"></span>
              <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown()"></span>
            </div>
          </ng-container>
          <widget-value class="land-registry-tenure-widget-header" [align]="'left'" [color]="'white'" [bold]="true">{{'landRegistryTenure.labelTitle' | rdTranslate}}</widget-value>
        </th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionName" [reflists]="reflists" [topicReflist]="'ref_l3_land_registry_tenure'"
                              [editMode]="editMode" [rows]="rows" [leftColspan]="6" [rightColspan]="6" [data]="widgetData ? widgetData : null"
                              [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRow$"
                              [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$"
                              [moveCurrentRowDown]="moveCurrentRowDown$" (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)"
                              class="land-registry-tenure-tl-section">
      </rd-textandlist-section>
    </tbody>
  </table>
</div>
